import * as action_type from './../actions/header/action_types';
import {setLanguage} from './../../utils/helper'
const initialState = {
    countryCode: '',
    localLanguage:''
}
const HeaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case action_type.SELECT_LANGUAGE:
            let localLang=setLanguage(action.lang);
            sessionStorage.setItem('lang', localLang);
            sessionStorage.setItem('countryCode', JSON.stringify({ countryCode: action.lang }));
            return Object.assign({}, state, {
                countryCode: action.lang,
                localLanguage:localLang
            });
        default:
            return state;
    }
}

export default HeaderReducer;


// WEBPACK FOOTER //
// ./src/redux/reducers/headerReducer.js